<div class="card flex justify-content-center">
    <div header="Header" class="dialog-content" style="margin-top: 5%;">
    	<div [innerHTML]="terms"></div>
    </div>
    <div class="p-dialog-footer">
        <button type="button" pButton (click)="closeTermsAndCondition($event)">Luk</button>
    </div>
</div>